import React, { useEffect } from 'react';
import M from 'materialize-css';

const Contact = () => {
  useEffect(() => {
    // Initialize form validation
    const form = document.querySelector('.contact-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        // Here you would typically send the form data to a server
        // For now, just show a confirmation message
        M.toast({html: 'Message sent! We\'ll get back to you soon.', classes: 'rounded'});
        form.reset();
      });
    }
  }, []);

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-image">
          <div className="center-align" style={{ padding: '20px' }}>
            <img
              src="/images/chris-call-me.png"
              alt="Christopher McHaffie - Contact Me"
              className="circle responsive-img"
              style={{ width: '200px', height: '200px', objectFit: 'cover', border: '3px solid var(--primary-color)' }}
            />
          </div>
        </div>
        <div className="login-form">
          <h3 className="brand-accent">3D Printing</h3>
          <h4>Contact Us</h4>
          <p className="grey-text">We'd love to hear from you. Fill out the form below to get in touch.</p>

          <div className="divider-custom"></div>

          <form className="contact-form">
            <div className="input-field">
              <i className="material-icons prefix">person</i>
              <input id="name" type="text" className="validate" required />
              <label htmlFor="name">Full Name</label>
            </div>

            <div className="input-field">
              <i className="material-icons prefix">email</i>
              <input id="email" type="email" className="validate" required />
              <label htmlFor="email">Email Address</label>
            </div>

            <div className="input-field">
              <i className="material-icons prefix">phone</i>
              <input id="phone" type="text" className="validate" />
              <label htmlFor="phone">Phone Number (Optional)</label>
            </div>

            <div className="input-field">
              <i className="material-icons prefix">message</i>
              <textarea id="message" className="materialize-textarea" required></textarea>
              <label htmlFor="message">Your Message</label>
            </div>

            <div className="row">
              <div className="col s12">
                <button className="btn-large waves-effect waves-light right" type="submit" name="action">
                  Send Message
                  <i className="material-icons right">send</i>
                </button>
              </div>
            </div>
          </form>

          <div className="row" style={{ marginTop: '30px' }}>
            <div className="col s12">
              <p className="grey-text">Or contact us directly:</p>
              <div className="contact-info">
                <p><i className="material-icons tiny">email</i> 3dmakerspacestudio@gmail.com</p>
                <p><i className="material-icons tiny">phone</i> +27 84 687 5248</p>
                <p><i className="material-icons tiny">location_on</i> 137 Ninth Road, Pomona, KemptonPark</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
